const RED_COEFFICIENT = 0.2126;
const GREEN_COEFFICIENT = 0.7152;
const BLUE_COEFFICIENT = 0.0722;
const LOW_COEFFICIENT = 1 / 12.92;
const REVERSE_LUMINANCE_COEFFICIENT = 1.6;


function adjustGamma(_) {
  return Math.pow((_ + 0.055) / 1.055, 2.4);
}

function rgbToSRGB({ red: r, green: g, blue: b }) {
  return {
    red: r / 255,
    green: g / 255,
    blue: b / 255,
  };
}

function convertParam(colorParam) {
  return colorParam <= 0.03928 ? colorParam * LOW_COEFFICIENT : adjustGamma(colorParam);
}

function relativeLuminance({ red: rsRGB, green: gsRGB, blue: bsRGB }) {
  const r = convertParam(rsRGB) * RED_COEFFICIENT;
  const g = convertParam(gsRGB) * GREEN_COEFFICIENT;
  const b = convertParam(bsRGB) * BLUE_COEFFICIENT;

  return r + g + b;
}

function luminance(a, b) {
  return b > a ? (b + 0.05) / (a + 0.05) : (a + 0.05) / (b + 0.05);
}

const hexCharacters = 'a-f\\d';
const match3or4Hex = `#?[${hexCharacters}]{3}[${hexCharacters}]?`;
const match6or8Hex = `#?[${hexCharacters}]{6}([${hexCharacters}]{2})?`;
const nonHexChars = new RegExp(`[^#${hexCharacters}]`, 'gi');
const validHexSize = new RegExp(`^${match3or4Hex}$|^${match6or8Hex}$`, 'i');

function hexToRgb(hex) {
  if (nonHexChars.test(hex) || !validHexSize.test(hex)) {
    throw new TypeError('Expected a valid hex string');
  }

  hex = hex.replace(/^#/, '');

  if (hex.length === 8) {
    hex = hex.slice(0, 6);
  }

  if (hex.length === 4) {
    hex = hex.slice(0, 3);
  }

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  const n = Number.parseInt(hex, 16);
  // eslint-disable-next-line no-bitwise
  const red = n >> 16;
  // eslint-disable-next-line no-bitwise
  const green = (n >> 8) & 255;
  // eslint-disable-next-line no-bitwise
  const blue = n & 255;

  return { red, green, blue };
}


function rgbColorLuminance(a, b, isSRGB = false) {
  if (!isSRGB) {
    a = rgbToSRGB(a);
    b = rgbToSRGB(b);
  }
  return luminance(relativeLuminance(a), relativeLuminance(b));
}

function hexColorLuminance(a, b) {
  return rgbColorLuminance(hexToRgb(a), hexToRgb(b));
}

function needReverseTextColorByBackgroundHex(color, reversCoefficient = REVERSE_LUMINANCE_COEFFICIENT) {
  return needReverseTextColorByBackground(hexToRgb(color, false, reversCoefficient));
}

function needReverseTextColorByBackground(color, isSRGB = false, reversCoefficient = REVERSE_LUMINANCE_COEFFICIENT) {
  const white = isSRGB ? { red: 1, green: 1, blue: 1 } : { red: 255, green: 255, blue: 255 };
  return rgbColorLuminance(white, color, isSRGB) < reversCoefficient;
}

export const ColorUtils = {
  rgbColorLuminance,
  hexColorLuminance,
  hexToRgb,
  needReverseTextColorByBackground,
  needReverseTextColorByBackgroundHex,
  REVERSE_LUMINANCE_COEFFICIENT,
};

